const text = {
  toTitleCase(str: string) {
    return str.replace(/\w\S*/g, txt => {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  },
  firstLetterUppercase(str: string) {
    return str.charAt(0).toUpperCase() + str.substr(1);
  },
  replaceUnderScoresWithSpaces(str: string) {
    return str.replace(/_/g, ' ');
  }
};

export { text };
